import { Paper, Stack, Typography } from "@mui/material";
import { FC } from "react";

import PasswordForm from "./PasswordForm/PasswordForm";
import ProfileForm from "./ProfileForm/ProfileForm";

const UserProfile: FC = () => {
  return (
    <Stack direction="column" spacing={2.5}>
      <Paper sx={{ p: { xs: 1.5, sm: 3 }, borderRadius: 2 }}>
        <Typography variant="headingLG" fontWeight={500}>
          User profile
        </Typography>
        <Typography
          variant="labelMD"
          sx={{
            mt: 0.25,
            color: (t: any) => t.palette.brandText?.secondary ?? "#818181",
          }}
        >
          Profile settings
        </Typography>
      </Paper>

      <Paper sx={{ borderRadius: 2 }}>
        <ProfileForm />
      </Paper>

      <Paper sx={{ borderRadius: 2 }}>
        <PasswordForm />
      </Paper>
    </Stack>
  );
};

export default UserProfile;
